import aa from "../AdminPortal/adminApp.module.css";
import { DateTimePickerSplit } from "../../ui";
import {
  buildDatetimePresets,
  toDatetimeLocalValue,
} from "../../../utils/pollSchedule";

export default function PollDateTimeField({
  value,
  onChange,
  label,
  hint,
  presets = buildDatetimePresets(),
}) {
  const activePreset =
    presets.find((p) => toDatetimeLocalValue(p.getDate()) === value)?.id ||
    null;

  return (
    <div className={aa.pollDatetimeField}>
      {label ? <span className={aa.pollDatetimeLabel}>{label}</span> : null}
      {hint ? <p className={aa.hubHint}>{hint}</p> : null}
      <div className={aa.pollDatetimePresets} role="group" aria-label="Быстрый выбор">
        {presets.map((preset) => {
          const on = activePreset === preset.id;
          return (
            <button
              key={preset.id}
              type="button"
              className={on ? aa.pollGroupChipOn : aa.pollGroupChip}
              aria-pressed={on}
              onClick={() => onChange(toDatetimeLocalValue(preset.getDate()))}
            >
              {preset.label}
            </button>
          );
        })}
      </div>
      <DateTimePickerSplit value={value} onChange={onChange} />
    </div>
  );
}
